import React from "react";
import SharedSwitchWhatsApp from "../../../../components/whatsapp/SwitchWhatsApp";

const InstructorSwitchWhatsApp = () => (
  <SharedSwitchWhatsApp basePath="/dashboard/instructor/menu/whatsapp" />
);

export default InstructorSwitchWhatsApp;
